import crews from "csi/access/crews";
import csiAction from "csi/action";
import Action from "csi/def/Action";
import { Context } from "csi/def/Context";
import locale from "csi/locale";
import { ATTR_TYPE } from "csi/typings";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import _ from "lodash";
import OwnershipTypeRenderer from "src/Apparel/OwnershipTypeRenderer";

const SizeChartOwnershipTypeRenderer = declare(OwnershipTypeRenderer, {
	/**
     * @override
     */
	canToggle(ctx: Context): boolean {
		return !xml.nodeIsFrozen(ctx.cache.getNode(ctx.getContextNode().CurrentRevision)) &&
        	crews.isInRoles(["Product Specification Administrator", "TDS - Size Chart Administrator"], ctx.getContextNode());
	},

	/**
     * @override
     * Call unlink action if SizeChart is linked to Shape
     */
	onToggle(ctx: Context, refNode: HTMLElement): void {
		const action = _.extend(new Action(), {
			m_id: locale.typeAction("SizeChart", "ClearSizeChartLinksToShape"),
			classController: "ProductSpec.SizeChart.UnlinkSizeChartController",
			m_postAction: "postActionRefresh",
		});
		action.resolve();
		csiAction.invoke(ctx.view, refNode, action);
	},

	/**
     * @override
     * Owned - If the SizeChart.ShapeSizeChart = empty
     * Linked - If the SizeChart.ShapeSizeChart = !empty
     * Referenced  - If SizeChart parent is a shape AND sizeChart.RefFromStyles is !empty
     *             - If SizeChartReview parent is not a style
     */
	getOwnershipType(ctx: Context): string {
		const parent = ctx.getNodeParent();
		if (parent != null && parent[ATTR_TYPE] !== "Style" && ctx.defView.m_idType !== "Shape") {
			return this.OWNERSHIP_TYPE_REFERENCED;
		}
		return xml.isValidURL(ctx.getNode()?.ShapeSizeChart) ? this.OWNERSHIP_TYPE_LINKED : this.OWNERSHIP_TYPE_OWNED;
	},

	/**
     * @override
	 * Display toggle if the SizeChart.ShapeSizeChart = !empty and not in popup view
     */
	shouldDisplayToggle(ctx: Context): boolean {
		return xml.isValidURL(ctx.getNode()?.ShapeSizeChart) && !ctx.view.bPopup;
	},

});

export = SizeChartOwnershipTypeRenderer;


